import "./button.scss";

interface IButton {
  name: string;
  type?: string;
  icon?: JSX.Element;
  isLoading?: boolean;
  loadingText?: string;
  onClick?: () => void;
}

export default function Button({
  name,
  type,
  icon,
  isLoading,
  loadingText,
  onClick,
}: IButton) {
  const buttonClassName = `button ${type}`;

  return (
    <button className={buttonClassName} onClick={onClick} disabled={isLoading}>
      {icon}
      {isLoading ? loadingText || name : name}
    </button>
  );
}
